
// State Object for DealsRoyalty. Dont directly mutate it anywhere except the deals/mutations.js file
export const dealsRoyaltyState = {
  dealsRoyaltyData: null,
  dealsList: null,
  dealsDetails: null,
}


